import { connect } from 'react-redux';
import RenewalListing from './renewalListing';
import { bindActionCreators } from 'redux';
import {
  getRenewalListingList,
  getSiteFilters,
  UploadFlat,
} from 'services/redux/brandActivtion/sitesListing/action';

const mapStateToProps = (state) => ({
  siteListData: state.baSiteListingReducer.renewalBaListing,
  siteFilters: state.baSiteListingReducer.siteFiltersData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getRenewalListingList,
      getSiteFilters,
      UploadFlat,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RenewalListing);
